export default __webpack_public_path__ + "media/src/features/open-house-registration-my-activity/assets/calendar-1c65c31714e8b77f81d6c28b92cde95e.svg";